import { Offer } from '@wwt/entities/search-response'

import { cn } from '@/shared/lib/cn'
import { Button, ButtonProps } from '@/shared/ui/Button.tsx'
import { UnderDevelopment } from '@/shared/ui/UnderDevelopment.tsx'

import { useReserve } from '../model/useReserve.ts'

interface ReserveButtonProps extends ButtonProps {
	offer: Offer | null
	className?: string
}

/**
 * Why we use here button's instead of links?
 *
 * Because now we do not support the reservation of the offer in another tab.
 * When we can do it, we will need to replace it with Link
 *
 * @author Ivan Shchedrovskyi
 */
export const ReserveButton = ({
	offer,
	className,
	...props
}: ReserveButtonProps) => {
	const { onButtonClick, name, title, isDisabled } = useReserve(offer)

	return isDisabled ? (
		<UnderDevelopment asChild>
			<Button
				className={cn('xl:h-16 xl:px-3.5 xl:py-5', className)}
				data-wwt-id="room-offer__reserve-button--unique"
				variant="default"
				size="default"
				key="reserve-button"
				onClick={onButtonClick}
				title={title}
				disabled={isDisabled}
				{...props}
			>
				{name}
			</Button>
		</UnderDevelopment>
	) : (
		<Button
			className={cn('xl:h-16 xl:px-3.5 xl:py-5', className)}
			data-wwt-id="room-offer__reserve-button--unique"
			variant="default"
			size="default"
			key="reserve-button"
			onClick={onButtonClick}
			title={title}
			{...props}
		>
			{name}
		</Button>
	)
}
